<template>
  <tr class="billing-payment-table__item">
    <td class="billing-payment-table__data createdAt">
      <div class="billing-payment-table__data_column-name">
        {{ $t('date') }}
      </div>
      <div class="billing-payment-table__data_data">
        {{ formatDateDefault(billingPayment.createdAt) }}
      </div>
    </td>
    <td class="billing-payment-table__data id">
      <div class="billing-payment-table__data_column-name">
        {{ $t('id') }}
      </div>
      <div class="billing-payment-table__data_data">
        {{ billingPayment.id }}
      </div>
    </td>
    <td class="billing-payment-table__data status">
      <VChip
        :color="color"
      >
        {{ billingPayment.status }}
      </VChip>
    </td>
    <td class="billing-payment-table__data itemType">
      <div class="billing-payment-table__data_column-name">
        {{ $t('itemType') }}
      </div>
      <div class="billing-payment-table__data_data">
        {{ billingPayment.itemType }}
      </div>
    </td>
    <td class="billing-payment-table__data tariff">
      <div class="billing-payment-table__data_column-name">
        {{ $t('tariff') }}
      </div>
      <div class="billing-payment-table__data_data">
        {{ billingPaymentPlanTitle }}
      </div>
    </td>
    <td class="billing-payment-table__data amount">
      {{ formatCurrencyFromMoney(billingPayment.amount) }}
    </td>
  </tr>
</template>

<script>
import useNumberFormatter from '@/compositions/useNumberFormatter';
import useDateFormatter from '@/compositions/useDateFormatter';
import { computed, toRefs } from '@vue/composition-api';

export default {
  name: 'BillingPaymentItem',
  props: {
    billingPayment: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { billingPayment } = toRefs(props);
    const { formatCurrencyFromMoney } = useNumberFormatter();
    const { formatDateDefault } = useDateFormatter();

    const color = computed(() => {
      switch (billingPayment.value.rawStatus) {
        case ('failed'): {
          return 'red';
        }
        case ('new'): {
          return 'default';
        }
        case ('succeed'): {
          return 'green';
        }
        default: {
          return 'default';
        }
      }
    });

    const billingPaymentPlanTitle = computed(() => billingPayment.value?.plan?.title || billingPayment.value?.data?.plan?.title);

    return {
      formatCurrencyFromMoney,
      formatDateDefault,
      color,
      billingPaymentPlanTitle,
    };
  },
};
</script>

<style lang="scss" scoped>
.billing-payment-table {
  &__item {
    border-top: 1px solid #EEEEEE;
  }
  &__data {
    font-size: 0.9375rem;
    color: #212121;
    word-break: break-word;
    text-decoration: none;
    padding: 0.9375rem 0.5rem;
    text-align: center;
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    &_column-name {
      display: none;
    }
  }
}
@media #{map-get($display-breakpoints, 'md-and-down')} {
  .billing-payment-table__data {
    font-size: 0.875rem;
    padding: 0.625rem 0.25rem;
  }
}
@media screen and (max-width: 768px) {
  .billing-payment-table {
    &__item {
      display: flex;
      flex-direction: column;
      border-radius: 4px;
      background: #FFF;
      box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.10);
      border-top: none;
      margin-bottom: 10px;
      padding: 20px;
      position: relative;
    }
    &__data {
      display: flex;
      justify-content: space-between;
      padding: 10px 0;
      text-align: left;
      &:nth-child(2) {
        width: 100%;
      }
      &_column-name {
        display: block;
        color: #000;
        font-size: 13px;
        font-weight: 300;
        opacity: 0.4000000059604645;
        width: 50%;
        padding-right: 20px;
      }
      &_data {
        width: 100%;
      }
    }
  }

  .amount {
    position: absolute;
    font-size: 18px;
  }
  .status {
    position: absolute;
    right: 20px;
  }
  .createdAt {
    padding-top: 50px;
  }
}
</style>

<i18n lang="yml" locale="ru">
  itemType: Тип услуги
  id: Номер счета
  date: Дата
  tariff: Тариф
  </i18n>
  <i18n lang="yml" locale="en">
  itemType: Service type
  id: Billing ID
  date: Date
  tariff: Tariff
  </i18n>
